import { createApplicationService } from "./base/applicationServiceBase";
import { API } from "api/axios.config";
import { useMemo } from "react";

const DEPARTMENTS_BASE = "/Departments";

export const getAllDepartments = () => API.get(`${DEPARTMENTS_BASE}`);

export const editDepartment = (id, data) =>
  API.patch(`${DEPARTMENTS_BASE}/${id}`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

export const addDepartment = (data) =>
  API.post(`${DEPARTMENTS_BASE}`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

const departmentService = createApplicationService({
  name: "departments",
  apiFetchFn: getAllDepartments,
  apiAddFn: addDepartment,
  apiUpdateFn: editDepartment,
});

const departmentReducer = departmentService.reducer;
const getDepartments = departmentService.getData;
const addDepartments = departmentService.addData;
const updateDepartment = departmentService.updateData;
const useDepartments = departmentService.useData;

const getActiveDepartments = async () => {
  const departments = await getDepartments();
  return departments.filter((d) => d.active) || [];
};

const useActiveDepartments = () => {
  const { data, loading } = useDepartments();
  const activeDepartments = useMemo(() => data.filter((d) => d.active), [data]);
  return { data: activeDepartments, loading };
};

export {
  departmentReducer,
  getDepartments,
  addDepartments,
  updateDepartment,
  useDepartments,
  getActiveDepartments,
  useActiveDepartments,
};
